export default '2.6.0';



// WEBPACK FOOTER //
// ./src/lib/version.js